<template>
  <b-container class="pt-4 pl-0">
    <b-row no-gutters>
      <b-col cols="auto">
        <b-form-checkbox
            :disabled="readOnly"
            data-test-path="checkbox-to-get-other-report-version"
            v-model="selectedValue"
            class="custom-checkbox"
        >
          <span class="custom-label">{{ fieldLabel }}</span>
        </b-form-checkbox>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import FormsLoader from "@/components/forms/FormsLoader";
import FormsActions from "@/components/forms/FormsActions";
import FormsAI from "@/components/forms/FormsAI";
import ReportFilterSpec from "@/server/com/silkplm/engine/reports/filters/ReportFilterSpec";
import NumericFilterSpec from "@/server/com/silkplm/engine/forms/schema/definition/filters/NumericFilterSpec";
import ApplicationUserFilterDataModel from "@/server/com/silkplm/engine/reports/filters/ApplicationUserFilterDataModel";
import {isProxy, toRaw} from 'vue';

export default {
  name: "CheckboxFilterActivityInput",
  components: {},
  beforeMount() {
  },
  mounted() {
    this.selectedValue = this.state;
  },
  props: {
    filter: {default: null, type: ReportFilterSpec},
    fieldLabel: {default: "", type: String},
    state: {default: true, type: Boolean}
  },
  watch: {
    selectedValue: async function (newVal, oldVal) {
      await this.updateValue(newVal);
    },
  },
  methods: {
    async updateValue(state) {
      this.$emit('input', state);
    },
  },

  data: () => ({
    readOnly: false,
    selectedValue: null,
    formattedValue: ""
  })
}
</script>

<style scoped>
.custom-checkbox .custom-control-label .custom-label {
  position: relative;
  top: 0.10rem !important;
}
</style>
